module.exports = __webpack_public_path__ + "static/media/chevron-down.fe820ae6.svg";